<svg
	class="top-0 left-0 right-0 bottom-0 absolute"
	height="40"
	version="1.1"
	viewPort="0 0 40 40"
	width="40"
	xmlns="http://www.w3.org/2000/svg"
>
	<filter
		color-interpolation-filters="sRGB"
		filterUnits="userSpaceOnUse"
		height="44"
		id="filter0_d"
		width="44"
		x="0"
		y="0"
	>
		<feFlood flood-opacity="0" result="BackgroundImageFix" />
		<feColorMatrix
			in="SourceAlpha"
			type="matrix"
			values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
		/>
		<feOffset dy="1" />
		<feGaussianBlur stdDeviation="0.5" />
		<feColorMatrix
			type="matrix"
			values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
		/>
		<feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
		<feBlend
			in="SourceGraphic"
			in2="effect1_dropShadow"
			mode="normal"
			result="shape"
		/>
	</filter>
	<circle
		cx="20"
		cy="20"
		fill="transparent"
		r="16"
		stroke="white"
		style="
			filter: url(#filter0_d);
			stroke-width: 6px;
			stroke-dashoffset: 0;
			stroke-linecap: round;
			transition: stroke-dashoffset 1s linear;
		"
	></circle>
	<circle
		class="p-stroke-component-background"
		cx="20"
		cy="20"
		fill="transparent"
		r="14"
		stroke-dasharray="87.96"
		stroke-dashoffset="0"
		style="
			stroke-width: 6px;
			stroke-linecap: round;
			transition: stroke-dashoffset 1s linear;
		"
	></circle>
	<circle
		[style.strokeDashoffset]="strokeDashoffset"
		class="p-stroke-primary"
		cx="20"
		cy="20"
		fill="transparent"
		r="14"
		stroke-dasharray="87.96"
		stroke-dashoffset="0"
		style="
			stroke-width: 6px;
			stroke-linecap: round;
			transition: stroke-dashoffset 1s linear;
		"
		transform="rotate(-90, 20, 20)"
	></circle>
</svg>
<i class="spreeng spreeng-checkbox-checked"></i>
